export default "__VITE_ASSET__BVmRH_Eu__"